import { Button, TextField } from "@mui/material";
import { message } from "antd";
import { useState } from 'react';

export default function Filters({ setColorFilter, filterOrders, cleanFilterOrders }) {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const [colorFilter, setColorFilterLocal] = useState('');  

    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const handleColorChange = (e) => {
        setColorFilterLocal(e.target.value);  
        setColorFilter(e.target.value);
    };

    return (
        <div style={{ flexDirection: 'column' }}>

            <Button
                style={{ marginBottom: '15px' }}
                variant="contained"
                size="small"
                onClick={toggleAccordion}
            >
                {isAccordionOpen ? 'Cerrar Filtros' : 'Abrir Filtros'}
            </Button>

            {isAccordionOpen && (
                <div style={{ display: 'flex', flexDirection: 'row', margin: '20px 0px' }}>

                    <TextField
                        style={{ marginRight: '15px' }}
                        label="Color"
                        onChange={handleColorChange}  
                        value={colorFilter}  
                        type="text"
                        id="color"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    <Button
                        style={{ marginLeft: '15px', marginTop: "10px" }}
                        variant="contained"
                        size="small"
                        onClick={() => {
                            try {
                                filterOrders();
                            } catch (error) {
                                message.error(error.message);
                            }
                        }}
                    >
                        Filtrar
                    </Button>
                    <Button
                        style={{ marginLeft: '15px', marginTop: "10px" }}
                        variant="contained"
                        size="small"
                        onClick={() => {
                            cleanFilterOrders();
                            setColorFilterLocal('');  
                        }}
                    >
                        Limpiar filtro
                    </Button>

                </div>
            )}
        </div>
    );
}
